export default __webpack_public_path__ + "static/media/m-logo.66263cb8.svg";